/* eslint-disable max-len */
module.exports = {
  // ================ TEXTS FOR SITE ELEMENTS ================
  p: {
    moredetailed: "More detailed...",
    send: "Send",
    changetheme: "Change color theme",
    usermenu: "User's menu",
    userpage: "User parameters",
    userexit: "<i class='fa fa-sign-out'></i>&nbsp;Exit",
    userlogin: "<i class='fa fa-sign-in'></i>&nbsp;Enter",
    gotoportal: "<i class='fa fa-share-square-o'></i>&nbsp;PORTAL GC-NN",
    usrexit: "Exit",
    usrlogin: "Enter",
    fieldlogin: "User login",
    fieldpass: "Password",
    authFormTitle: "User authorization form",
    buttonlogin: "Sign in",
    userLoggedSuccess: "You have successfully authorized",
    userLoggedFailed: "Authorisation Error",
    nullLoginOrPass: "Required arguments are missing - login & pass",
    missingADhash: "Srvbg-server rejected your authorization. You must be in the Internal network. Did you forget turn on the OpenVPN?",
    incorrectUserIP: "IP-address of the Authorized user does not match on Srvbg-server",
    redirection: "Redirection...",
    userLoggedError1: "It was ",
    userLoggedError2: " attempt for last hour. If you send irregular accounting data 5 times, you will be blocked!",
    userLoggedWarning: "After 5 attempts by unsuccessful authorization, you will be blocked!",
    changelng: "Change language",
    banned: "You are banned!",
    attentionban: "You are not blocked yet. But if this happens, then only the site owner will be able to remove you from the blacklist.",
    noscript: "TO WORK THE SITE, YOU MUST ALLOW THE SCRIPTS EXECUTION",
    messagesent: "The message has been sent",
    cantsendmessage: "Cannot send a message",
    contractornotfound: "Counterparty is not found",
    spmoduleoff: "SharePoint module disabled by the administrator",
    vibermoduleoff: "Viber module disabled by the administrator",
    emptystring: "Empty string",
    emptyarray: "Empty array",
    nophonenumbers: "Phone numbers are not specified",
    noinn: "INN (TIN) is not specified",
    norecipients: "No recipients",
    incorrentfields: "Some fields are filled incorrectly",
    fileconversionerror: "File Conversion Error",
    qrcodenouri: "No QR-code encoding URI passed",
    chartnodata: "No data was transmitted for plotting the chart",
    noidbuildobj: "Construction object ID not passed",
    viberBotOnSubscribe: `Hello! I'm Viber-Bot. You will be able to receive messages from me in Viber on current tasks and other alerts. 
      But first I need to identify you. Send your phone number like this: +79100000000`,
    viberBotNeedSubscribe: "At first I need to identify you. Send your phone number like this: +79100000000",
    viberBotUnderstandOnlyTextMessages: "Sorry. I understand only text messages",
    viberBotDummyAnswer: "There is no need to write comments in this chat. No one will see them anyway. The chat only works one way Bot -> Viber",
    viberBotIalreadyKnowYou: "You are already registered in Viber-Bot",
    userWithThisPhoneNotFound: "User with this phone is not found in database 'users'",
    viberBotHello1: "Hello, ",
    viberBotHello2: "! Your ID: ",
    viberBotHello3: ". You are successfully connected to this chat and will now receive messages from Viber-Bot",
    errorPageTitle: "Server-side error during page rendering attempt",
    tooltipServicesHeadLink: "Read about it in our Knowledge Base"
  },
  // ================ IMAGES ================
  i: {
    programmerisworking: { title: "The programmer is working on this site section.", src: "/img/general/programmer-is-working.png" }
  },
  // ================ HEADER AND FOOTER ================
  header: {
    title: "Geocontrol-NN",
    navlinks: {
      title: "Geocontrol-NN",
      text: "Technical support for pre-fabrication and site activities",
      linkhome: "Home",
      linkservices: "Our services",
      linksubservices: [
        { text: "NDT-Laboratory", href: "/services/ndt" },
        { text: "Mechanical Tests", href: "/services/mex" },
        { text: "Construction Lab", href: "/services/stroylab" },
        { text: "Geodesy", href: "/services/geodesy" }
      ],
      linkcontacts: "Contacts",
      phone: "7-800-505-65-45",
      email: "mail@gc-nn.com"
    }
  },
  prefootersms: {
    text1: "Take a phone and call Us!",
    text2: "Send Your request to e-mail:",
    phone: "7-800-505-65-45",
    email: "mail@gc-nn.com",
    text3: "Send a message to us using this form. We will call back you or send an answer on your Viber / WhatsApp / Telegram",
    formph1: "Your name",
    formph2: "Your phone +7...",
    formph3: "Type your questions here..."
  },
  footer: {
    linkprivacy: "Privacy",
    linkbacktotop: "Back to top",
    linkpresentation: "See our presentation"
  },
  other: {
    geography: "Geography of our facilities"
  }
};
/* eslint-enable max-len */
